<template>
  <div class="container">
    <div class="row">
      <div class="col offset-9 d-flex justify-content-end pe-0">
        <span v-if="timer < timeLimit / 2">{{
          (countdown - timeLimit / 2) | asTime
        }}</span>
        <span v-else>{{ countdown | asTime }}</span>
      </div>
    </div>
    <div class="row" v-html="description"></div>
    <form>
      <div class="row">
        <!-- <div class="col-6 col-sm-4 col-md-3" v-for="question in shuflledQuestions[timer<timeLimit/2]"> -->
        <div
          class="col-4 col-md-3"
          v-for="question in shuflledQuestions[timer < timeLimit / 2]"
          :key="question.id"
        >
          <!-- <div class="row py-4"> -->
          <div
            class="row py-4 d-flex justify-content-center"
            style="border: 1px solid #d7d7d7"
          >
            <div class="col-auto d-flex justify-content-end">
              <img
                :src="question.picture"
                style="max-width: 100%; height: auto"
              />
            </div>
            <!-- TODO: mask this with a function call -->
            <div
              v-if="timer < timeLimit / 2"
              class="col-auto d-flex align-items-center"
            >
              <div>
                <h3>{{ question.solution }}</h3>
              </div>
            </div>
            <div v-else class="col col-md-3 offset-2 offset-sm-3 offset-md-0">
              <div
                class="form-check"
                v-for="(choice, index) in question.choices"
                :key="question.id * 100 + index"
              >
                <input
                  class="form-check-input"
                  type="radio"
                  :name="'radio-group-' + question.id"
                  v-model="question.response"
                  :value="choice"
                  :id="`radio-${question.id}-${index}`"
                />
                <label
                  class="form-check-label"
                  :for="`radio-${question.id}-${index}`"
                  >{{ choice }}</label
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'RememberingInformation'
}
</script>

<style scoped>
</style>
